/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export class AddModule {
    async can(id, inspector) {
        const exists = inspector.moduleById(id);
        if (exists) {
            return {
                success: false,
                error: `Unable to add module: module with id "${id}" already exists`,
            };
        }
        return {
            success: true,
            affectedNodes: [],
            affectedModules: [id],
            affectedGraphs: [],
        };
    }
    async do(spec, context) {
        if (spec.type !== "addmodule") {
            throw new Error(`Editor API integrity error: expected type "addmodule", received "${spec.type}" instead.`);
        }
        const { id, module } = spec;
        const { graph, mutable } = context;
        const inspector = mutable.graphs.get("");
        const can = await this.can(id, inspector);
        if (!can.success) {
            return can;
        }
        graph.modules ??= {};
        graph.modules[id] = module;
        return {
            success: true,
            affectedNodes: [],
            affectedModules: [id],
            affectedGraphs: [],
        };
    }
}
//# sourceMappingURL=add-module.js.map